import React from 'react'
import PropTypes from 'prop-types'
import TopPanelMenu from 'components/TopPanelMenu'

export default class extends React.Component {
  static contextTypes = {
    permissions: PropTypes.object
  }

  render() {
    // const {permissions} = this.context

    // const MyIntegrationsMenuItem = permissions.show.includes('@features/myIntegrations') ? {
    //   to: '/settings/integrations',
    //   title: 'My integrations'
    // } : null

    return (
      <TopPanelMenu
        items={[
          {to: '/settings/channels', title: 'Channels'},
          {to: '/settings/utm-mapping', title: 'UTM mapping'},
          {to: '/settings/referrer-mapping', title: 'Referrer mapping'},
          {to: '/settings/custom-mapping', title: 'Custom mapping'},
          // MyIntegrationsMenuItem,
          // {to: '/settings/categories', title: 'Site Structure'},
          {to: '/settings/domains', title: 'Internal Whitelist'},
          {to: '/settings/countries', title: 'Country Filter'}
        ]}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/SettingsView/menu.js